import { useMemo } from 'react';

import { LOCAL_STORAGE_TOKEN } from 'shared/constants';

import { useLocalStorageState } from './useLocalStorageState';

/**
 * Custom React hook that determines if a session token exists in local storage.
 *
 * @returns {boolean} True if a session token is present, otherwise false.
 */
export function useHasSession(): boolean {
  const [token] = useLocalStorageState<string | undefined>(LOCAL_STORAGE_TOKEN);

  return useMemo(() => Boolean(token), [token]);
}
